import { t } from "i18next";
import { ApiError, ApiServiceError } from "libs/api";
import { toast } from "react-hot-toast";

export const toastServerError = (error: ApiServiceError<ApiError>) => {
  const errorMessage = error.response?.data.message;

  if (!errorMessage) {
    return;
  }

  if (typeof errorMessage === "string") {
    toast.error(t(errorMessage));
  } else {
    errorMessage.forEach((message) => toast.error(t(message)));
  }
};
